import { Alert } from 'omakase';
import { FunctionComponent, useEffect } from 'react';
import { GiftCardBalance } from 'components/account/GiftCardBalance';
import { Theme, css } from '@emotion/react';
import { checkTockGiftCardBalance } from 'actions/TockGiftCardActions';
import { getGiftCardBalance } from 'selectors/patronSelectors';
import { set } from 'actions/NavigationActions';
import { useDispatch, useSelector } from 'react-redux';
import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import LoadingComponent from '@tock/shared/components/LoadingComponent';

export const GiftCardBalanceRoute: FunctionComponent<{}> = () => {
  const giftCardBalance = useSelector(getGiftCardBalance);
  const dispatch = useDispatch();
  const isTockGiftCardDeprecated = useFeatureFlag('GOODBYE_TOCK_GIFT_CARDS');

  useEffect(() => {
    dispatch(
      set({
        hasLogo: true,
        hasBack: false,
      })
    );
    dispatch(checkTockGiftCardBalance());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="Account-content">
      <LoadingComponent isBallPulse isLoading={giftCardBalance.isRequesting}>
        {isTockGiftCardDeprecated ? (
          <div
            css={({ spacing }: Theme) => css`
              padding: ${spacing(2)}px;
            `}
          >
            <Alert color="info">
              TBD message about your prior gift card balance having been reimbursed.
            </Alert>
          </div>
        ) : (
          <GiftCardBalance />
        )}
      </LoadingComponent>
    </div>
  );
};
